import {createReducer} from '@reduxjs/toolkit'
import {
  closeMonthlyCalendarEvent,
  closeMonthlyCalendarPopup,
  openMonthlyCalendarEvent,
  openMonthlyCalendarPopup,
  setCalendarReferenceDay,
  setCalendarReferenceMonth,
} from '../actions/calendar-layout'
import {loadCalendarEvents} from '../actions/events'
import {CalendarLayout} from '../types/state'

const defaultState: CalendarLayout = {
  referenceMonth: null,
  referenceDay: null,
  today: null,
  month: {},
  monthly: {
    selectedDate: null,
    selectedEventId: null,
  },
  days: {},
  weekDayNames: [],
  loadedPages: [],
  events: {},
  demoEvents: {},
  loading: null,
}

export const calendarLayout = createReducer(defaultState, builder => {
  builder
    .addCase(setCalendarReferenceMonth, (state, {payload}) => {
      state.referenceMonth = payload
      state.monthly = {
        ...state.monthly,
        selectedDate: null,
        selectedEventId: null,
      }
    })
    .addCase(loadCalendarEvents.pending, (state, {meta}) => {
      state.loading = meta.arg.origin
    })
    .addCase(loadCalendarEvents.fulfilled, (state, {payload, meta}) => {
      if (payload) {
        const reset = meta.arg.fullReset
        const {referenceDate, weekDayNames, month, today, events, days} = payload.dates.calendar

        const mergedEvents = {...state.events}
        for (const key in events) {
          mergedEvents[key] = mergedEvents[key] ? [...new Set(mergedEvents[key].concat(events[key]))] : events[key]
        }

        state.referenceMonth = referenceDate
        state.today = today
        state.weekDayNames = weekDayNames
        state.month = {
          ...state.month,
          ...month,
        }
        state.monthly = {
          ...state.monthly,
          selectedDate: null,
          selectedEventId: null,
        }
        state.events = reset ? events : mergedEvents
        state.days = {...state.days, ...days}
        state.loadedPages = reset ? [referenceDate] : [...state.loadedPages, referenceDate]
      }
      state.loading = null
    })
    .addCase(loadCalendarEvents.rejected, state => {
      state.loading = null
    })
    .addCase(openMonthlyCalendarPopup, (state, {payload}) => {
      state.monthly = {
        ...state.monthly,
        selectedDate: payload,
        selectedEventId: null,
      }
    })
    .addCase(closeMonthlyCalendarPopup, state => {
      state.monthly = {
        ...state.monthly,
        selectedDate: null,
      }
    })
    .addCase(openMonthlyCalendarEvent, (state, {payload}) => {
      const {eventId, selectedDate} = payload
      const day = selectedDate
        ? selectedDate
        : Object.keys(state.events).find(key => state.events[key].includes(eventId))

      state.monthly = {
        ...state.monthly,
        selectedDate: day,
        selectedEventId: eventId,
      }
    })
    .addCase(closeMonthlyCalendarEvent, state => {
      state.monthly = {
        ...state.monthly,
        selectedEventId: null,
      }
    })
    .addCase(setCalendarReferenceDay, (state, {payload}) => {
      state.referenceDay = payload
    })
})
